import { render, staticRenderFns } from "./MessageOrganizerModal.vue?vue&type=template&id=514737ff&"
import script from "./MessageOrganizerModal.vue?vue&type=script&lang=ts&"
export * from "./MessageOrganizerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports